import useCapabilities from "@/hooks/useCapabilities";
import { hasNationalSectionBypassRole } from "@/pages/events/_nationalSectionBypass";
import { ROLE } from "@/providers/AuthorizationProvider/types";

/**
 * Hook for checking university staff permissions and access controls.
 * University staff users are restricted to university routes only and cannot access system pages outside of their university.
 */
export const useUniversityStaffPermissions = () => {
  const { hasRole, loaded } = useCapabilities();
  const isUniversityStaff = hasRole(ROLE.UNIVERSITY_STAFF);
  // Campus-only staff: university_staff without nationally_scoped? HQ roles.
  // Same set as Backoffice::User#nationally_scoped? / NATIONAL_SECTION_BYPASS_ROLES.
  const isCampusOnlyUniversityStaff = isUniversityStaff && !hasNationalSectionBypassRole({ loaded, hasRole });

  return {
    /** True if the current user is university staff */
    isUniversityStaff,

    /** True if the user is campus-only university staff (not nationally scoped HQ) */
    isCampusOnlyUniversityStaff,

    /** True if the user can access people pages (non-university staff) */
    canAccessPeoplePages: !isUniversityStaff,

    /** True if the user can access non-university routes (non-university staff) */
    canAccessNonUniversityRoutes: !isUniversityStaff,

    /** True if person profile actions should be shown (non-university staff) */
    shouldShowPersonProfileActions: !isUniversityStaff,

    /** True if facility profile actions should be shown (non-university staff) */
    shouldShowFacilityProfileActions: !isUniversityStaff
  };
};
